 <template>
  <b-container fluid class="px-1">  
    <b-row class="justify-content-center mx-0">
      <h2 style="text-align: center;color: #fff;">Silverdor Software Introduces 2 Products</h2>
    </b-row>
    <b-row class="justify-content-center mx-0">
      <h4 class="whitetitle">Telegram Group & Channel Builder</h4>
    </b-row>
    <b-row class="justify-content-center mx-0">
      <h4 class="whitetitle">Telegram DM Sender</h4>
    </b-row>
    <b-row class="justify-content-center" no-gutters>
        <b-col xs="12" md="8" class="p-2">
          <b-embed 
          type="video" 
          aspect="16by9" 
          controls 
          autoplay 
          loop
          poster="https://silverdormanager.univerhome.com/uploads/media/mainthumb.png">     
          <source src="https://silverdormanager.univerhome.com/uploads/media/mainvideo.mp4" type="video/mp4">
          </b-embed>
        </b-col>
    </b-row>

    <b-row class="justify-content-center mt-2 mb-2" no-gutters>
      <b-icon icon="chevron-double-down" variant="primary" font-scale="3" animation="cylon-vertical" aria-hidden="true"></b-icon>
    </b-row>

    <b-row class="justify-content-center mt-4 mb-4" no-gutters> 
      <h2 class="whitetitle">Telegram Group & Channel Builder Features</h2>
    </b-row>

    <b-row no-gutters>
        <b-col xs="12" md="6" class="p-4 d-flex justify-content-center">
           <b-card
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="list-check" class="rounded-circle bg-primary p-4" variant="light"></b-icon></div>
               <h4 class="featitle">Telegram Scraper</h4>
              <p>Telegram scraper will help you scrape members from other Telegram groups or your channels, the list will be saved inside the software database you can export it and save it locally to proceed another Telegram scraping.</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col xs="12" md="6" class="p-4 d-flex justify-content-center">
           <b-card
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="journal-plus" class="rounded-circle bg-primary p-4" variant="light"></b-icon></div>
              <h4 class="featitle">Telegram Adder</h4>
              <p>The Telegram adder feature gets the scraped list, and start adding members to your selected Telegram group or channel, based on your settings. Members are added automatically over time until adding all the Telegram members.</p>
            </b-card-text>
          </b-card>
        </b-col>
        
        
      </b-row>

    <b-row class="justify-content-center mt-2 mb-2" no-gutters>
      <b-icon icon="chevron-double-down" variant="success" font-scale="3" animation="cylon-vertical" aria-hidden="true"></b-icon>
    </b-row>

    <b-row class="justify-content-center mt-4 mb-4" no-gutters> 
      <h2 class="whitetitle">Telegram DM Sender Features</h2>
    </b-row>

    <b-row no-gutters>
        <b-col xs="12" md="6" class="p-4 d-flex justify-content-center">
           <b-card
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="list-check" class="rounded-circle bg-success p-4" variant="light"></b-icon></div>
               <h4 class="featitledm">Telegram Scraper</h4>
              <p>To send bulk Telegram messages, you need to scrape Telegram usernames first, the Telegram scraper inside the Telegram DM Sender product, will help you scrape Telegram usernames from Telegram groups, or from group messages, or from channel comments, you can set the tool to scrape only recently active users.</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col xs="12" md="6" class="p-4 d-flex justify-content-center">
           <b-card
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="envelope" class="rounded-circle bg-success p-4" variant="light"></b-icon></div>
              <h4 class="featitledm">Telegram Sender</h4>
              <p>After finishing the scraping step, the Telegram sender feature will start sending bulk telegram messages to the scraped usernames based on your settings. You can cutomize the waiting time between each message sent, you can upload custom list of messages, you can also manage the sending with multiple accounts through multiple proxies.</p>
            </b-card-text>
          </b-card>
        </b-col>
        
      </b-row>

    <b-row class="justify-content-center mt-2 mb-2" no-gutters>
      <b-icon icon="chevron-double-down" variant="warning" font-scale="3" animation="cylon-vertical" aria-hidden="true"></b-icon>
    </b-row>

    <b-row class="justify-content-center mt-4 mb-4" no-gutters> 
      <h2 class="whitetitle" >Common Features</h2>
    </b-row>

      <b-row no-gutters>
        <b-col xs="12" md="4" class="p-4 d-flex justify-content-center">
          <b-card
            style="max-width: 25rem;"
            class="mb-4 bg-white text-center"
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="box-arrow-in-down" class="rounded-circle bg-warning p-4" variant="light"></b-icon></div>
               <h4 class="text-warning">Import Files</h4>
              <p>Both products allow you to import members list, usernames list, accounts list, messages list, proxies list and sessions files... The imports depend on the product you are using and the data required by the product to work correctly.</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col xs="12" md="4" class="p-4 d-flex justify-content-center">
           <b-card
            style="max-width: 25rem;"
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="box-arrow-up" class="rounded-circle bg-warning p-4" variant="light"></b-icon></div>
              <h4 class="text-warning">Export Files</h4>
              <p>Silverdor products allow you to export and store your scraped data (members data list or usernames list), and keep the files saved locally in your device, maybe for another Telegram group/channel building project or another Telegram bulk messages sending project.</p>
            </b-card-text>
          </b-card>
        </b-col>
        
        <b-col xs="12" md="4" class="p-4 d-flex justify-content-center">
          <b-card
            style="max-width: 25rem;"
            class="mb-4 bg-white text-center"
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="sliders" class="rounded-circle bg-warning p-4" variant="light"></b-icon></div>
              <h4 class="text-warning">Full Control</h4>
              <p>You have a full control of your tools from the settings, you can control how the adding process will work, how the bulk messages sending will be processed, you can set the amount of users to add, amount of  messages to send, enable proxy or not, random sleep time, scraping from where and how..., we made it customizable and flexible.</p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      <b-row no-gutters>
        <b-col xs="12" md="4" class="p-4 d-flex justify-content-center">
           <b-card
            style="max-width: 25rem;"
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="life-preserver" class="rounded-circle bg-warning p-4" variant="light"></b-icon></div>
              <h4 class="text-warning">Support</h4>
              <p>Our support team is ready to help you enjoying the power of Silverdor products. We are available 24/7 to answer all your questions and solve any technical issues.</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col xs="12" md="4" class="p-4 d-flex justify-content-center">
           <b-card
            style="max-width: 25rem;"
            class="mb-4 bg-white text-center "
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="shield-check" class="rounded-circle bg-warning p-4" variant="light"></b-icon></div>
              <h4 class="text-warning">Safe</h4>
              <p>Both of the Silverdor products, the Telegram Group & Channel Builder and the Telegram DM Sender, were designed by a professional team of engineers to be 100% safe. We keep updating our products based on the latest Telegram updates.</p>
            </b-card-text>
          </b-card>
        </b-col>
        <b-col xs="12" md="4" class="p-4 d-flex justify-content-center">
          <b-card
            style="max-width: 25rem;"
            class="mb-4 bg-white text-center"
            align="center"
          >
            <b-card-text>
              <div  style="font-size: 5rem;"><b-icon icon="signpost-split" class="rounded-circle bg-warning p-4" variant="light"></b-icon></div>
              <h4 class="text-warning">Tutorials</h4>
              <p>After becoming one of the Silverdor happy customers , you will get access to the purchased product documentation giving you more details about: Installation, activation, settings… and how to use the product interface correctly step by step.</p>
            </b-card-text>
          </b-card>
        </b-col>
      </b-row>
      
      <b-row class="justify-content-center mt-2 mb-2" no-gutters>
      <b-icon icon="chevron-double-down" variant="primary" font-scale="3" animation="cylon-vertical" aria-hidden="true"></b-icon>
    </b-row>

    <b-row class="justify-content-center mt-4 mb-4" no-gutters> 
      <h2 class="whitetitle" id="pricing">Telegram Group & Channel Builder Pricing</h2>
    </b-row>
    <b-row v-if="getPrice.length>0"  class="d-flex justify-content-center" no-gutters>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
              bg-variant = "secondary"
              no-body
              style="width: 100%; margin-left: 10px; margin-right: 10px"
              >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPrice[0].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPrice[0].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">1 Computer</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in features" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>
                <b-card-body>
                  <b-button 
                  class="w-100 mt-2 mb-2 p-2"
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1"
                  variant="primary"
                  @click.prevent="ordernow(getPrice[0].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  <span>Order Now</span></b-button>
                  <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="crypto" 
                  variant="primary"
                  @click.prevent="crypto"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
                bg-variant = "primary"
                no-body
                style="width: 100%; margin-left: 10px; margin-right: 10px"
                >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPrice[1].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPrice[1].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">5 Computers</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in features" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>

                <b-card-body>
                  <b-button
                  class="w-100 mt-2 mb-2 p-2" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1"
                  variant="warning"
                  @click.prevent="ordernow(getPrice[1].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  <span>Order Now</span></b-button>
                  <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="crypto" 
                  variant="warning"
                  @click.prevent="crypto"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
        
              </b-card>
            </b-col>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
                bg-variant = "secondary"
                no-body
                style="width: 100%; margin-left: 10px; margin-right: 10px "
            >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPrice[2].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPrice[2].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">10 Computers</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in features" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>
                <b-card-body>
                    <b-button 
                  class="w-100 mt-2 mb-2 p-2" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1" 
                  variant="primary"
                  @click.prevent="ordernow(getPrice[2].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Order Now</span></b-button>
                    <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="crypto" 
                  variant="primary"
                  @click.prevent="crypto"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
            </b-card>
            </b-col>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
                bg-variant = "primary"
                no-body
                style="width: 100%; margin-left: 10px; margin-right: 10px"
            >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPrice[3].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPrice[3].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">25 Computers</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in features" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>
                <b-card-body>
                  <b-button
                  class="w-100 mt-2 mb-2 p-2" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1"
                  variant="warning"
                  @click.prevent="ordernow(getPrice[3].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Order Now</span></b-button>
                    <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="crypto" 
                  variant="warning"
                  @click.prevent="crypto"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
            </b-card>
            </b-col>     
        </b-row>
       
     <b-row class="justify-content-center mt-2 mb-2" no-gutters>
      <b-icon icon="chevron-double-down" variant="success" font-scale="3" animation="cylon-vertical" aria-hidden="true"></b-icon>
    </b-row>   

    <b-row class="justify-content-center mt-4 mb-4" no-gutters> 
      <h2 class="whitetitle" id="dmpricing">Telegram DM Sender Pricing</h2>
    </b-row>
    <b-row v-if="getPriceDm.length>0" class="d-flex justify-content-center" no-gutters>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
              bg-variant = "secondary"
              no-body
              style="width: 100%; margin-left: 10px; margin-right: 10px"
              >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPriceDm[0].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPriceDm[0].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">5 Accounts</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in dmfeatures" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>
                <b-card-body>
                  <b-button 
                  class="w-100 mt-2 mb-2 p-2"
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1"
                  variant="success"
                  @click.prevent="ordernow(getPriceDm[0].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  <span>Order Now</span></b-button>
                  <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="cryptoDM" 
                  variant="success"
                  @click.prevent="cryptoDM"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
              </b-card>
            </b-col>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
                bg-variant = "success"
                no-body
                style="width: 100%; margin-left: 10px; margin-right: 10px"
                >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPriceDm[1].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPriceDm[1].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">10 Accounts</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in dmfeatures" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>

                <b-card-body>
                  <b-button
                  class="w-100 mt-2 mb-2 p-2" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1"
                  variant="warning"
                  @click.prevent="ordernow(getPriceDm[1].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                  <span>Order Now</span></b-button>
                  <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="cryptoDM1" 
                  variant="warning"
                  @click.prevent="cryptoDM"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
        
              </b-card>
            </b-col>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
                bg-variant = "secondary"
                no-body
                style="width: 100%; margin-left: 10px; margin-right: 10px "
            >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPriceDm[2].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPriceDm[2].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">20 Accounts</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in dmfeatures" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>
                <b-card-body>
                    <b-button 
                  class="w-100 mt-2 mb-2 p-2" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1" 
                  variant="success"
                  @click.prevent="ordernow(getPriceDm[2].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Order Now</span></b-button>
                    <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="cryptoDM2" 
                  variant="success"
                  @click.prevent="cryptoDM"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
            </b-card>
            </b-col>
            <b-col xs="12" md="6" xl="3" class="mt-1 d-flex justify-content-center">
              <b-card
                bg-variant = "success"
                no-body
                style="width: 100%; margin-left: 10px; margin-right: 10px"
            >
                <template #header>
                  <h4 class="mb-0 text-center" style="color: #fff;">{{getPriceDm[3].product}}</h4>
                  <h4 class="m-2 text-center" style="color: #fff;">${{getPriceDm[3].price}}</h4>
                  <h6 class="m-2 text-center" style="color: #fff;">Lifetime License</h6>
                </template>
                <b-list-group flush>
                  <b-list-group-item variant="secondary">
                      <p class="mb-0 text-center">Unlimited Accounts</p>   
                  </b-list-group-item>
                  <b-list-group-item v-for="feature in dmfeatures" :key="feature" variant="secondary">
                      <P class="mb-0 text-center">{{feature}}</P>
                  </b-list-group-item>
                </b-list-group>
                <b-card-body>
                  <b-button
                  class="w-100 mt-2 mb-2 p-2" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="boost-1"
                  variant="warning"
                  @click.prevent="ordernow(getPriceDm[3].id)"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Order Now</span></b-button>
                    <b-button 
                  class="w-100" 
                  size="md"
                  :disabled="loading"
                  squared
                  id="cryptoDM3" 
                  variant="warning"
                  @click.prevent="cryptoDM"
                  >
                  <span v-show="loading" class="spinner-border spinner-border-sm mr-1"></span>
                    <span>Pay With Cryptocurrency</span></b-button>
                </b-card-body>
            </b-card>
            </b-col>     
        </b-row>
        
  

      <b-row class="justify-content-center mt-4 mb-4" no-gutters>
        <h2 class="whitetitle">Compatible With Windows/Mac OS</h2>
      </b-row>

      <b-row class="justify-content-center" no-gutters>
        <b-col xs="12" md="8" class="p-2">
          <b-img class="width-img" center fluid src="https://silverdormanager.univerhome.com/uploads/media/Silverdor-mac-windows.png" alt="Silverdor Mac os and Windows image"></b-img>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-4 mb-4" no-gutters>
          <h2 class="whitetitle">Testimonials</h2>
      </b-row>

      <b-row class="justify-content-center" no-gutters>
        <b-col xs="12" md="6" class="p-4">      
              <div style="color: #2D2D2E; min-height: 185px; background:white; text-align: center;padding: 20px;border-radius: 10px; height: 100%;">
                <h4>Chris</h4>
              <p>“I was fortunate to test the software before the public release, it will definitely get you hooked. It’s fast and reliable with straight to the point guide…”<br>
              -United Kingdom-</p>
              </div>
        </b-col>
      
        <b-col xs="12" md="6" class="p-4">
              <div style="color: #2D2D2E; min-height: 185px; background:white; text-align: center;padding: 20px;border-radius: 10px;height: 100%;">
              <h4>Lisa</h4>
              <p>“The customer support is spectacular, they’ve answered any questions and inquiries I’ve had within hours every single time…”<br>
              -United States-</p></div>
        </b-col>
      </b-row>

      <b-row class="justify-content-center" no-gutters>
        <b-col xs="12" md="6" class="p-4">
              <div style=" color: #2D2D2E; min-height: 185px; background:white; text-align: center;padding: 20px;border-radius: 10px;height: 100%;">
              <h4>Lee</h4>
              <p>
              “I’ve been using the software for over two months now and it’s performing exceptionally well, all the features are working as described…”<br>
              -Hong Kong- </p></div>
        </b-col>
   
        <b-col xs="12" md="6" class="p-4">
              <div style=" color: #2D2D2E; min-height: 185px; background:white; text-align: center;padding: 20px;border-radius: 10px;height: 100%;">
              <h4>Jack</h4>
              <p>
              “Silverdor Makes connecting with potential fans & clients 100% easier, my content reaches way more people and I’m able to focus more on content creation! Easy to learn program, great help with any issues and the results are incredible!”<br>-Canada-
              </p></div>
        </b-col>
      </b-row> 
    
      <b-row class="justify-content-center mt-4 mb-4" no-gutters>
          <h2 class="whitetitle">FAQ</h2>
      </b-row>

      <b-row class="justify-content-center" no-gutters>
        <b-col xs="12" md="6" class="p-4">
              <div style="color: #2D2D2E; min-height: 250px; background:white;padding: 20px;border-radius: 10px; height: 100%;">
              <h4>Why Silverdor Tools are very useful?</h4>
              <p>Building Telegram group or channel or sending bulk Telegram messages is one of the newest internet marketing strategies. Both the Telegram Group & Channel Builder and the Telegram DM Sender, are powered by a Telegram scraper and come with and easy and flexible software interface, putting between your hands powerful features to automate all things: scraping and building groups and channels and also sending bulk Telegram messages. Silverdor can build large Telegram groups and channels, and send bulk Telegram messages, helping you to promote your products and services. The tools are one time paid, no monthly charges.</p>

              <h4>How Silverdor will help my business?</h4>
              <p>People who joined your group or channel by the Silverdor software, or who received your Telegram bulk messages, will be a targeted audience based on your business niche. For example you want to build a Telegram group or channel about Trading, or send bulk messages to people who are interested on this niche, Basically you will scrape users from groups/channels related to Trading niche, then you start adding/sending, of course a lot of them will engage with the products and services you are promoting.</p>

              <h4>Does Telegram allow using bots?</h4>
              <p>Telegram is one of the platforms that allow using bots. Silverdor is based on the same concept of Telegram bots. So, you can easily automate Telegram group and channel building or automate Telegram bulk message sending, and let the software do the work for you.</p>

              <h4>Do I need advanced computer skills to use Silverdor Tools ?</h4>
              <p>Not at all, you can easily install and activate our products, whether the Telegram Group & Channel Builder or the Telegram DM Sender, then start using them after few minutes.<br>

              Our tutorials will help you enjoy all our products features. You will learn how to install, activate and get a full description of each product feature.</p></div>
        </b-col>
      
        <b-col xs="12" md="6" class="p-4 ">
              <div style="color: #2D2D2E; min-height: 250px; background:white;padding: 20px;border-radius: 10px; height: 100%;">
              <h4>Are the Silverdor Products safe?</h4>
              <p>Of course yes, because all activities done are authorized by Telegram. Telegram allows you to build communities and add targeted members to your Telegram groups and channels, Telegram scraper feature will help you scrape from groups or your channels and then add them safely to your groups or channels. Also you can send Telegram bulk messages safely. Our tutorials will explain all to avoid any problems.</p>

            <h4>Do you have an Affiliate Program?</h4>
              <p>Yes, as an affiliate marketer you can join our affiliate program, we offer large commissions. To join the program <a href="https://silverdor.com/Signup">signup from here</a></p>

            <h4>Why Telegram group and channel building?</h4>
              <p>Telegram groups/channels building is one of the best marketing strategies, similar to Facebook groups, Telegram allows you to build and manage a community of users under a group or a channel, you can go live with them too, For example if you have a store, creating a Telegram group or channel is a powerful idea to promote your products/services to the Telegram community. Silverdor comes with an All-in-One tool helping you automatically scrape users and build Telegram groups and channels faster than you imagine. You can also reach them by sending bulk Telegram messages.</p>

            <h4>What requirements & operating systems your products support?</h4>
              <p>Silverdor Products support:<br>

              <b>RAM/Processor:</b><br>
              Any computer with 2GB of RAM or above.<br>
              <b>Operating systems:</b><br>
              Mac OS: All versions.<br>
              Windows: Windows XP, Windows Vista, Windows 7, 8, 8.1, 10, 11, Windows Server.</p></div>
        </b-col>
      </b-row>

      <b-row class="justify-content-center mt-4 mb-2" no-gutters> 
            <b-button 
              class="p-2" 
              size="md"
              rounded
              id="scrol23" 
              variant="secondary"
              @click.prevent="scrollto"
            >Back to Pricing</b-button>
      </b-row>
     
  </b-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
 
  data() {
    return {
      visible: false,
      loading: false,
      features: ['Telegam scraper','Telegram Adder','Telegram web Integrated','Custom Settings','Custom Proxy','Restore and Backup','CSV import/Export','Support 24/7','Tutorial & Docs'],
      dmfeatures: ['Telegam scraper','Telegram Sender','Multiple Proxies','Custom Messages','Custom Chats List','Upload Sessions Files','Custom Settings','Import/Export','Support 24/7','Tutorial & Docs']
    };
  },
  mounted() {
      this.$store.dispatch("getprice");
  },
  methods:{
    crypto(){
      this.$analytics.fbq.event('silverdorBtcOrderBtn');
      window.location.replace('https://silverdor.com/crypto-payment');
    },
    cryptoDM(){
      this.$analytics.fbq.event('silverdorBtcOrderBtn');
      window.location.replace('https://silverdor.com/crypto-payment-dm');
      
    },
    scrollto(){
      document.getElementById('pricing').scrollIntoView();
    },

    ordernow(id){
        this.loading = true;
        this.$analytics.fbq.event('silverdorOrderBtn');
        this.$store.dispatch("ordernow", {product: id, referrer: ''});
      },
  },

  components: { 
  },

  computed: {
    ...mapGetters(["getPrice", "getPriceDm"]),
  }
};
</script>
<style scoped>
 .border-left{
  background: #482b69;
  border: none;
 }
 .sectitle{
  color: #0E0092;
  text-align: center;
 }
 .featitle{
  color: #037bfc;
  text-align: center;
 }
 .whitetitle{
  color: #0E0092;
  text-align: center;
 }
 .price-style{
  text-align: center;
  color: #25964d;
  font-family: 'almendra display',Sans-serif;
  font-weight: 700; 
}
.bg-trans{
  background: transparent;
  border: none;
  padding: 10px 20px;
}
.bg-trans-p6{
  background: transparent;
  border: none;
  padding: 5px 20px;
}
.txt-grey{
  color: white;
}
.txt-grey1{
  color: grey;
}
.iconpostion{
  position: relative;
  top: 5px;
  margin-right: 10px;
}
.bg-orge{
  background-color: #ff9400;
}
.bg-blue1{
  background-color: #007aff;
}
.bg-puplea{
  background-color: #6f42c1;
}
.bg-pupleb{
  background-color: #c7a2fc;
}
.bg-greenb{
background-color: #fff;
}
.bg-img{
  background-color: transparent;
  background-image: linear-gradient(140deg,#1A1060 17%,#f2295b 100%);
}
.width-img{
  max-width: 300px;
}
@media not screen and (max-width: 767px) {
  .padd-x{
    padding-right: 10%;
    padding-left: 10%;
  }
}

</style>